
export function xlog(...args) {
    if (process.env.NODE_ENV === 'development') {
        const stack = new Error().stack;
        const callerInfo = stack.split('\n')[2]; // 获取调用者的堆栈信息
        const timestamp = new Date().toISOString(); // 获取当前时间的 ISO 格式
        console.log(
            '%c调用时间: ' + timestamp + '%c\n调用位置: ' + callerInfo.trim() + '%c\n日志内容:',
            'color: gold;', // 时间部分的颜色
            'color: gray;',  // 调用位置的颜色
            'color: white;', // 内容部分的颜色
            ...args          // 添加展开的 args 以显示日志内容
        );

    }
}




